module.exports = __webpack_public_path__ + "img/setra-logo.45f4edeb.svg";